enum RecurrencePatternName {
    Once = 'Once',
    Weekly = 'Weekly',
    Every2weeks = 'Every 2 weeks',
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}

export default RecurrencePatternName;
